import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { TextField, Button } from "@mui/material";
import API_URL from "../../config/api";

import axios from "axios";
import "./ResetPasswordConfirm.css";

const ResetPasswordConfirm = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get("token");

    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [feedback, setFeedback] = useState(null);

    useEffect(() => {
        if (!token) {
            setFeedback({ type: "error", message: "Token inválido ou ausente." });
        }
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFeedback(null);

        if (password !== confirm) {
            setFeedback({ type: "error", message: "As senhas não coincidem." });
            return;
        }

        try {
            await axios.post(`${API_URL}/api/User/reset-password/confirm`, {
                token: token,
                newPassword: password,
            });
            setFeedback({
                type: "success",
                message: "Senha redefinida com sucesso! Você pode fazer login novamente.",
            });
            setTimeout(() => navigate("/"), 3000);
        } 
        catch (error) {
            console.error(error);
            setFeedback({
                type: "error",
                message: "Erro ao redefinir a senha. Tente novamente.",
            });
        }
    };

    return (
        <div className="reset-confirm-container">
            <form className="reset-confirm-form" onSubmit={handleSubmit}>
                <h2 className="reset-confirm-title">Redefinir Senha</h2>
                <p className="reset-confirm-instructions">
                    Digite sua nova senha abaixo.
                </p>
                <TextField
                    fullWidth
                    label="Nova Senha"
                    type="password"
                    size="small"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="reset-confirm-input"
                    required
                />
                <TextField
                    fullWidth
                    label="Confirmar Senha"
                    type="password"
                    size="small"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    className="reset-confirm-input"
                    required
                />
                <Button
                    variant="contained"
                    type="submit"
                    className="reset-confirm-button"
                    fullWidth
                >
                    Redefinir Senha
                </Button>

                {feedback && (
                    <p className={`reset-confirm-feedback ${feedback.type}`}>
                        {feedback.message}
                    </p>
                )}

                <p className="back-to-login" onClick={() => navigate("/")}>
                    Voltar para login
                </p>
            </form>
        </div>
    );
};

export default ResetPasswordConfirm;
